const ua = navigator.userAgent;
// 是否企微环境
const isWXWork = /wxwork/i.test(ua);
// 是否微信环境
const isWeixin = !isWXWork && /micromessenger/i.test(ua);
// 是否QQu案件ing
const isQQ = /\sQQ(?!Browser)/i.test(ua);
// 是否QQ浏览器
const isQQBrowser = /MQQBrowser/i.test(ua);

export {
  isWXWork,
  isWeixin,
  isQQ,
  isQQBrowser,
};
